import { Stethoscope, Info } from "lucide-react";

const members = [
    { name: "Dr. [Name]", role: "Dentist" },
    { name: "Dr. [Name]", role: "Dentist" },
    { name: "Clinic Support Team", role: "Patient Care" },
];

export const Team = () => (
    <section id="team" className="bg-slate-50 py-20 sm:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-2xl mx-auto text-center mb-14">
                <p className="text-xs font-bold uppercase tracking-[0.22em] text-teal-600 mb-4">Meet The Team</p>
                <h2 className="text-3xl sm:text-4xl font-semibold tracking-tight text-slate-900">
                    Your Dental Care Team
                </h2>
                <p className="mt-4 text-base leading-relaxed text-slate-600">
                    A friendly, professional team dedicated to making every visit comfortable.
                </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 max-w-4xl mx-auto" data-testid="team-grid">
                {members.map((m, i) => (
                    <article
                        key={i}
                        data-testid={`team-card-${i + 1}`}
                        className="bg-white rounded-2xl p-8 text-center shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-slate-100 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_20px_40px_rgb(0,0,0,0.08)]"
                    >
                        <span className="mx-auto h-24 w-24 rounded-full bg-gradient-to-br from-teal-50 to-sky-100 border border-teal-100 flex items-center justify-center mb-5">
                            <Stethoscope className="h-10 w-10 text-teal-600" strokeWidth={1.2} />
                        </span>
                        <h3 className="text-lg font-semibold text-slate-900">{m.name}</h3>
                        <p className="mt-1 text-sm font-medium text-teal-600">{m.role}</p>
                        <p className="mt-3 text-xs text-slate-400">Profile details coming soon</p>
                    </article>
                ))}
            </div>

            <p className="mt-10 mx-auto max-w-xl text-center flex items-center justify-center gap-2 text-xs text-slate-400" data-testid="team-placeholder-note">
                <Info className="h-3.5 w-3.5 shrink-0" />
                Team profiles will be updated shortly with full details.
            </p>
        </div>
    </section>
);
